module.exports = __webpack_public_path__ + "static/media/ambulance.338b02e3.svg";